import { ProductDisabledType } from '@/features/YTLive/LiveProducts/getProductDisabledType';

const ytLive = {
  'Learn more': '了解更多',
  'Field youtubeId': 'YouTube 頻道 ID',
  'Field youtubeUrl': 'YouTube 頻道 URL',
  'Field brandHomeUrl': '商店 URL',
  'Field date': '預計直播時間',
  'Field date - description':
    '請注意！在您按下前往開播按鈕時，您的商品才會實際展示於 Google Merchant Center / YouTube 後台，以上兩大步驟設定完成後，建議您於正式直播的三天前，在預計直播的 YouTube 頻道先擇期試播一次，以確保順利開播。\n*提醒您，因 YouTube / Google Merchant Center 平台上傳商品限制，僅能選擇當下 24 小時後的時間作為您的預計直播時間。',
  'Live Products': '直播商品',
  'Live Products - counter': '({{count}}/{{max}})',
  'Live Products - description':
    '請提供您預計直播的時間。選擇好後，隱藏商品將會隨著您選擇到的預計直播時間露出於商店前台及 YouTube 前後台。另外提醒您：因 Google Merchant Center 及 YouTube 平台限制，在您選擇到「預計直播時間」後，我們在您直播前 24 小時將不再開放編輯時間。',
  'Live Products - min error': '直播商品是必填項目，請選擇直播商品',
  'Live Products - max error':
    '一個直播間僅限添加 {{count}} 個商品，請減少直播商品數量',
  'Live Products - nav content': '選擇或建立直播的商品',
  'Add Products': '選擇直播商品',
  'Live Products columns - Product': '商品',
  'Live Products columns - Inventory': '可售數量',
  'Live Products columns - Status': '狀態',
  'Live Products status - reminder on': '缺貨提醒：開啟',
  'Live Products status - reminder off': '缺貨提醒：關閉',
  'Live Products status - hidden': '隱藏商品',
  'Live Products status - schedulePublishAt': '於 {{date}} 上架',
  'Live Products status - availableStartTime start': '開始銷售：{{date}}',
  'Live Products status - availableStartTime period': '銷售時間：{{date}}',
  'Live Products status - availableStartTime end': '銷售結束：{{date}}',
  [`Live Prdoucts disabled_${ProductDisabledType.unpublished}`]: '已下架',
  [`Live Prdoucts disabled_${ProductDisabledType.emptyPrice}`]:
    '無法添加無價格商品',
  [`Live Prdoucts disabled_${ProductDisabledType.hiddenPrice}`]:
    '無法添加隱藏價格商品',
  'LiveProductsPicker - SearchBar placeholder': '搜尋商品名稱或 SPU',
  'LiveProductsPicker - No result': '找不到商品',
  'LiveProductsPicker - No result description':
    '請嘗試更改關鍵字或篩選套用詞/編號',
  'LiveProductsPicker - View selected products':
    '檢視已選商品 ({{count}}/{{max}})',
  'LiveProductsPicker - View all products': '檢視全部商品',
  'Youtube Admin Preparation': 'YouTube 後台準備',
  'Youtube Admin Preparation - description':
    '由於 YouTube 平台限制，暫不支援於 SHOPLINE 後台直接開播，更多直播功能敬請期待。如需終止直播請至 YouTube 後台操作。開始直播售賣商品前，請參考以下步驟：',
  'Youtube Admin Preparation - nav content': '需要在平台設定做好準備',
  'Youtube Admin Preparation StepOne': '於 YouTube 工作室設定頻道展示商品',
  'Youtube Admin Preparation StepOne - description':
    '當您設定好 Google Merchant Center Content API 後，商品將自動上傳至您的 Google Merchant Center 及 YouTube Live Shopping 後台，您可以至 YouTube 後台管理設定中心將想要在直播當下展示的商品勾選起來。',
  'Youtube Admin Preparation StepTwo': '標記直播中要展示的商品',
  'Youtube Admin Preparation StepTwo - description':
    '並可於直播當下標記釘選商品至頻道中，讓您的買家能夠邊看邊買',
  'Youtube Admin Preparation StepThree': '在預定時間開播並置頂商品',
  'Youtube Admin Preparation StepThree - description':
    '直播期間，可搭配置頂功能讓介紹的商品更顯眼。',
  'Finish Setting': '完成',
  'Finish Setting - description': '完成以上設定步驟之後，就可以馬上開播了！',
  'Start Streaming': '前往 YouTube 開播',
  'exceeded the LIVE Broadcast time':
    '此直播間已失效（超過直播時間），本次編輯時間將不儲存；欲進行開播請新增一新的直播間',
  'Youtube Tnc':
    '於設定本功能時您已充分知悉相關規定，請參閱 <YoutubePrivacyLink></YoutubePrivacyLink>及以下相關規定。',
  'Youtube Privacy': 'YouTube 隱私權政策',
  'Youtube Tnc Detail':
    '請注意，當您串接 YouTube Shopping 時，代表您同意將網路商店中來自 YouTube 的訂單數據傳輸給 YouTube。',
  'Setup Guide YouTube Shopping Setup': 'YouTube Shopping 直播間設定',
  'Field Channel': '頻道',
  'Setup Guide Choose Channel Title': '選擇 YouTube 頻道',
  'Setup Guide Choose Channel Description':
    '注意：商店包含隱藏商品，在所有串接的 YouTube 頻道後台將顯示這些商品。',
  'Setup Guide Choose Channel Dropdown Placeholder': '請選擇',
  'Setup Now': '前往啟用',
  'Setup Guide No Available Channels': '商店沒有已串接的 YouTube 頻道',
  'Schedule Live Stream Title': '預計直播時間',
  'Schedule Live Stream Description':
    '請選擇您預計直播的時間，隱藏商品將在預計直播時間顯示於商店前台及 YouTube 前後台。\n*提醒您，因 Google Merchant Center 及 YouTube 平台上傳商品限制，僅能選擇當下 24 小時後的時間作為您的預計直播時間，且在直播前 24 小時不支援編輯時間。',
  'Live Stream Products Title': '直播商品',
  'Live Stream Products Description':
    '請選擇直播商品，在您按下儲存按鈕時，您的商品才會實際顯示於 Google Merchant Center / YouTube 後台。',
  'YouTube Preparation Title': 'YouTube 後台準備',
  'YouTube Preparation Description':
    '由於 YouTube 平台限制，暫不支援於 SHOPLINE 後台直接開播，終止直播也請至 YouTube 後台操作，更多直播功能敬請期待。\n開始直播販售商品前，請參考以下步驟：',
  'Account Linking YouTube Preparation StepOne':
    '1. 於 YouTube 工作室設定頻道展示商品',
  'Account Linking YouTube Preparation StepOne - description':
    '當您已完成 Google Merchant Center Content API 設定，商品將自動上傳至您的 Google Merchant Center 及 YouTube 後台，您可以至 YouTube 後台選取要在頻道展示的商品。',
  'Account Linking YouTube Preparation StepTwo': '2. 標記直播中要展示的商品',
  'Account Linking YouTube Preparation StepTwo - description':
    '您可以標記商品，使其展示在直播中，讓觀眾能夠邊看邊買。',
  'Account Linking YouTube Preparation StepThree':
    '3. 在預定時間開播並置頂商品',
  'Account Linking YouTube Preparation StepThree - description':
    '直播期間，可搭配置頂功能讓介紹的商品更顯眼。',
  'Finish YouTube Setting': '完成',
};

export default ytLive;
